(function ($, window) {
    $(function () {
        $('.js-add-to-cart').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $form = $this.closest('form');
            var form_action = $form.data('form-action');
            var selects = $form.find('.c-product-item__options select')
            var totalSelects = selects.length;
            $form.find('button').prop('disabled', true);

            selects.each(function() {
                var selectedItems = $(this).find('option:not(:first):selected').length;
                totalSelects -= selectedItems;
                if(selectedItems == 0){
                    $(this).closest('.c-option').addClass('error');
                }else{
                    $(this).closest('.c-option').removeClass('error');
                }
            });

            if(totalSelects !== 0) return;

            grecaptcha.ready(function () {
                grecaptcha.execute('6LdGTLgqAAAAAN6FRk1FGwMy0LDEZ-d_VjOB1trB', {action: form_action}).then(function (token) {
                    $form.find('[name="g-recaptcha-response"]').remove();
                    $form.prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
                    $form.submit();
                });
            });
        });

        // Input controls -/+
        $(document).on('click', '.c-number-input__increase, .c-number-input__decrease', function (e) {
            var $input = $(this).parent().find('input');
            var currentValue = parseInt($input.val());
            var lowestValue = $input.attr('min');
            var addValue = 1;
            var newValue = 0;
            var $form = $('.c-cart');
            var form_action = $form.data('form-action');

            if ($(this).hasClass('c-number-input__decrease')) {
                addValue = -1;
            }
            newValue = currentValue + addValue;
            if (newValue < lowestValue) {
                newValue = lowestValue;
            }

            $input.val(newValue);

            grecaptcha.ready(function () {
                grecaptcha.execute('6LdGTLgqAAAAAN6FRk1FGwMy0LDEZ-d_VjOB1trB', {action: form_action}).then(function (token) {
                    $form.find('[name="cart[g-recaptcha-response]"]').remove();
                    var recaptchaCreated = $form.prepend('<input type="hidden" name="cart[g-recaptcha-response]" value="' + token + '">');

                    if(recaptchaCreated.length){
                        $.post(
                            $form.attr('action'),
                            $form.serialize()
                        ).done(function (data) {
                            $('.js-cart').html(data);
                        });
                    }
                });
            });

            e.preventDefault();
        });

        // Fix number input values to set lowest number
        $(document).on('input', '.js-fix-number-values', function () {
            var lowestValue = $(this).attr('min');
            var $form = $('.c-cart');
            var form_action = $form.data('form-action');

            if (Math.abs(this.value) < lowestValue) {
                this.value = lowestValue;
            } else {
                this.value = Math.abs(this.value);
            }

            grecaptcha.ready(function () {
                grecaptcha.execute('6LdGTLgqAAAAAN6FRk1FGwMy0LDEZ-d_VjOB1trB', {action: form_action}).then(function (token) {
                    $form.find('[name="cart[g-recaptcha-response]"]').remove();
                    var recaptchaCreated = $form.prepend('<input type="hidden" name="cart[g-recaptcha-response]" value="' + token + '">');

                    if(recaptchaCreated.length){
                        $.post(
                            $form.attr('action'),
                            $form.serialize()
                        ).done(function (data) {
                            $('.js-cart').html(data);
                        });
                    }
                });
            });
        });

        $(document).on('click', '.c-cart-item__remove', function (e) {
            var $this = $(this);
            var uniqueID = $this.data('unique-id');
            var cartItem = $this.closest('.c-cart-item');
            cartItem.remove();

            $.post(
                $('.c-cart').attr('action'),
                {'remove_product': {'unique_id': uniqueID}}
            ).done(function (data) {
                $('.js-cart').html(data);
            });

            e.preventDefault();
        });

        $('.js-payment').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $form = $this.closest('form');
            var form_action = $form.data('form-action');
            $form.find('button').prop('disabled', true);

            grecaptcha.ready(function () {
                grecaptcha.execute('6LdGTLgqAAAAAN6FRk1FGwMy0LDEZ-d_VjOB1trB', {action: form_action}).then(function (token) {
                    $form.find('[name="cart[g-recaptcha-response]"]').remove();
                    $form.prepend('<input type="hidden" name="cart[g-recaptcha-response]" value="' + token + '">');
                    $form.submit();
                });
            });
        });
    });
})(jQuery, window);